import React from 'react';
import { Helmet } from 'react-helmet-async';
import Evaluations from './Evaluations';
import useRouter from '../../hooks/useRouter';
import PageHeading from '../../@communityshare/ui/PageHeading';
import Results from '../_common_results/Results';
import EvaluationEventEducatorComplete from '../evaluations-event-educators-filtered/complete/Evaluation';
import EvaluationEventEducatorPending from '../evaluations-event-educators-filtered/pending/Evaluation';
import { ClipboardDocumentListIcon } from '@heroicons/react/24/outline';
import MobileNavigation from '../evaluations/MobileNavigation';

export default function Layout(props) {
  const router = useRouter();

  return (
    <div className="p-8 space-y-8">
      <Helmet>
        <title>Explore Events</title>
      </Helmet>
      <MobileNavigation />
      <PageHeading
        breadcrumbs={['Evaluations', 'Events: Educators']}
        title="All Evaluations"
        description={(
          <>
            Event evaluations sent to an educator.
          </>
        )}
      />
      <Evaluations router={router}>
        {function(result) {
          return (
            <Results result={result} columns={1} resource="evaluations" emptyIcon={ClipboardDocumentListIcon}>
              {function(evaluationEventEducator) {
                if (evaluationEventEducator.data.completed) {
                  return (
                    <EvaluationEventEducatorComplete
                      key={evaluationEventEducator.id}
                      evaluation={evaluationEventEducator}
                    />
                  );
                }

                return (
                  <EvaluationEventEducatorPending
                    key={evaluationEventEducator.id}
                    evaluation={evaluationEventEducator}
                  />
                );
              }}
            </Results>
          );
        }}
      </Evaluations>
    </div>
  );
}
